import type { FilterableSelectOption } from './FilterableSelect';

/**
 * The comboboxes' shared matching rule: every whitespace-separated typed term
 * must appear somewhere in the option's label, secondary text or hidden
 * keywords (case-insensitive).
 */
export function matchesFilterableOption(option: FilterableSelectOption, input: string): boolean {
  const haystack = [option.label, option.secondary ?? '', ...(option.keywords ?? [])].join(' ').toLowerCase();
  return input
    .split(/\s+/)
    .filter((term) => term.length > 0)
    .every((term) => haystack.includes(term));
}
